import { configureStore } from '@reduxjs/toolkit'


import * as slices from './slices'

export const store = configureStore({ reducer: {
    global: slices.global,
    fleetMap: slices.fleetMap,
    fleetList: slices.fleetList,
    batteries: slices.batteries,
    requests: slices.requests,
    clients: slices.clients,
    users: slices.users,
    rates: slices.rates,
    rents: slices.rents,
    couriers: slices.couriers,
    client_hubs: slices.client_hubs,
    bikes: slices.bikes,
    ownerships: slices.ownerships,
    companies: slices.companies,
    countries: slices.countries,
    dashboard: slices.dashboard,
    histories: slices.histories,
    rentStatuses: slices.rentStatuses,
    payments: slices.payments,
    invitations: slices.invitations,
    telegram: slices.telegram,
    geofences: slices.geofences,
    damageReports: slices.damageReports,
    reservedBikes: slices.reservedBikes,
    companyIntegrations: slices.companyIntegrations,
    contractTemplates: slices.contractTemplates,
    paymentMethods: slices.paymentMethods,
    paymentLinks: slices.paymentLinks,
    tbankIntegration: slices.tbankIntegration,
    capabilities: slices.capabilities,
    staff: slices.staff,
    subscription: slices.subscription
}})

